var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1941_2121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 5.19615C42.5692 1.98076 49.4308 1.98076 55 5.19615L76.8372 17.8038C82.4064 21.0192 85.8372 26.9615 85.8372 33.3923V58.6077C85.8372 65.0385 82.4064 70.9808 76.8372 74.1962L55 86.8038C49.4308 90.0192 42.5692 90.0192 37 86.8038L15.1628 74.1962C9.59361 70.9808 6.16283 65.0385 6.16283 58.6077V33.3923C6.16283 26.9615 9.59361 21.0192 15.1628 17.8038L37 5.19615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9167 62.6872C54.2836 62.6872 62.6875 54.2832 62.6875 43.9163C62.6875 33.5495 54.2836 25.1455 43.9167 25.1455C33.5499 25.1455 25.1459 33.5495 25.1459 43.9163C25.1459 54.2832 33.5499 62.6872 43.9167 62.6872Z",
    fill: "#CBE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6042 38.2713C46.2917 37.8546 44.8959 38.1046 43.8959 38.8755C42.8751 38.1046 41.5209 37.8546 40.2084 38.2713C37.3751 39.188 36.4792 42.4171 37.2709 44.8755C38.4792 48.6463 42.4584 50.6046 43.8959 50.6046C45.2917 50.6046 49.3542 48.6046 50.5209 44.8755C51.3334 42.4171 50.4376 39.188 47.6042 38.2713Z",
    fill: "#0071FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8126 60.4792C66.1251 59.2083 64.6668 58.5 62.7085 58.5C61.2293 58.5 59.9585 59.1042 59.2085 60.1458C58.4585 61.1875 58.2918 62.5833 58.7501 63.9792C59.646 66.6875 61.2085 67.2917 62.0626 67.3958C62.1876 67.4167 62.3126 67.4167 62.4585 67.4167C63.3751 67.4167 64.7918 67.0208 66.1668 64.9583C67.271 63.3542 67.4793 61.75 66.8126 60.4792Z",
    fill: "#0071FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1941_2121",
    x: 0,
    y: 0,
    width: 92,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.579762 0 0 0 0 0.749505 0 0 0 0 1 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1941_2121"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.7667be0ccdccfb7b4d7316a5e1dded63.svg";
export { ForwardRef as ReactComponent };